// File: cms/frontend/src/actions/webHookAction.js

import {
  createWebhooks,
  fetchWebHooks,
  editWebHook,
  deleteWebHook,
  getWebHook,
} from "../api/api";

// Action to add a new webhook
export const addWebHook = (data) => async (dispatch) => {
  try {
    const res = await createWebhooks(data);

    if (res.status === 201) {
      dispatch({
        type: "WEBHOOK_CREATE_SUCCESS",
        status: res.status,
        payload: res.data.message,
      });
    } else {
      dispatch({
        type: "WEBHOOK_CREATE_FAIL",
        status: res.status,
        payload: res.data.message || "Something went wrong",
      });
    }

    return { success: true, message: res.data.message };
  } catch (error) {
    dispatch({
      type: "WEBHOOK_CREATE_FAIL",
      status: error.response?.status || 500,
      payload: error.response?.data?.message || "Something went wrong",
    });
    return {
      success: false,
      status: error.response?.status || 500,
      message: error.response?.data?.message || "Something went wrong",
    };
  }
};

// Action to fetch all webhooks for a workspace
export const getWebHooks = (workspaceId) => async (dispatch) => {
  try {
    const res = await fetchWebHooks(workspaceId);
    dispatch({
      type: "GET_ALL_WEBHOOKS",
      payload: res.data,
    });
    return {
      success: true,
      message: res.data.message,
    };
  } catch (err) {
    dispatch({
      type: "GET_ALL_WEBHOOKS_FAIL",
      payload: err.response?.data?.message || "Something went wrong",
    });
    return {
      success: false,
      message: err.response?.data?.message || "Something went wrong",
    };
  }
};

// Action to get a specific webhook by ID
export const getWebHookById = (workspaceId, id) => async (dispatch) => {
  try {
    const res = await getWebHook(workspaceId, id);
    dispatch({
      type: "GET_WEBHOOK",
      payload: res.data,
    });
    return {
      success: true,
      message: res.data.message,
    };
  } catch (err) {
    dispatch({
      type: "GET_WEBHOOK_FAIL",
      payload: err.response?.data?.message || "Something went wrong",
    });
    return {
      success: false,
      message: err.response?.data?.message || "Something went wrong",
    };
  }
};

// Action to update an existing webhook
export const updateWebHook = (id, data) => async (dispatch) => {
  try {
    const res = await editWebHook(id, data);
    if (res.status === 200) {
      dispatch({
        type: "WEBHOOK_UPDATE_SUCCESS",
        payload: res.data,
        status : res.status,
      });
    } else {
      dispatch({
        type: "WEBHOOK_UPDATE_FAIL",
        payload: res.data.message || "Something went wrong",
        status: res.status,
      });
    }
    return { success: true, message: res.data.message };
  } catch (error) {
    dispatch({
      type: "WEBHOOK_UPDATE_FAIL",
      payload: error.response?.data?.message || "Something went wrong",
      status: error.response?.status || 500,
    });
    return {
      success: false,
      message: error.response?.data?.message || "Something went wrong",
      status: error.response?.status || 500,
    };
  }
};

// Action to remove a webhook by ID
export const removeWebHooks = (id) => async (dispatch) => {
  try {
    const res = await deleteWebHook(id);
    if (res.status === 200) {
      dispatch({
        type: "DELETE_WEBHOOK",
        payload: id,
      });
    } else {
      dispatch({
        type: "DELETE_WEBHOOK_FAIL",
        payload: res.data.message || "Something went wrong",
      });
    }
    return { success: true, message: res.data.message };
  } catch (error) {
    dispatch({
      type: "DELETE_WEBHOOK_FAIL",
      payload: error.response?.data?.message || "Something went wrong",
    });
    return {
      success: false,
      message: error.response?.data?.message || "Something went wrong",
    };
  }
};
